import React from 'react';



type Props = {
	children: React.ReactNode,
};

const FormsList: React.FC<Props> = (props) => {
	const {
		children,
	} = props;

	const elements = React.Children.toArray(children).filter((child) => !!child);

	return (
		<div className="forms-list">
			{React.Children.map(
				elements,
				(child, index) => {
					return (
						<div
							className="forms-list__item"
							key={'forms-list-item-' + index}
						>
							{child}
						</div>
					);
				},
			)}
		</div>
	);
};



export default FormsList;
